import script from "./ConfigVisual.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigVisual.vue?vue&type=script&setup=true&lang=js"

import "./ConfigVisual.vue?vue&type=style&index=0&id=4abddb16&lang=scss"

export default script